<template>
  <v-card
    class="ma-0 pa-0 d-block shadow-none rounded-lg mt-0 mt-lg-3"
    :dir="$vuetify.rtl ? 'rtl' : 'ltr'"
    v-if="isLoaded"
  >
    <v-card-title class="font-weight-bolder text-dark-65 py-2 mb-1 pt-5">{{
      translateApiLabel(item.title)
    }}</v-card-title>
    <v-card-subtitle
      class="font-weight-bolder text-dark-25 py-2 mb-6 donut-card-subtitle"
      >{{ $t("visualizing_shipping_rates") }}</v-card-subtitle
    >
    <v-card-text class="d-block ma-0 pa-0 pb-2">
      <apexchart
        :options="chartOptions"
        :series="series"
        height="317px"
      ></apexchart>
    </v-card-text>
  </v-card>
  <v-skeleton-loader v-else type="card"></v-skeleton-loader>
</template>
<script>
import ApiService from "@/core/services/api.service";
import translateApiLabelMixin from "@/own/mixins/translateApiLabelMixin";

export default {
  name: "FulfillmentPerformanceDonutChartNew",
  mixins: [translateApiLabelMixin],
  props: ["item", "filterData"],
  data() {
    return {
      serverData: null,
      series: [],
      isLoaded: false,
    };
  },
  methods: {
    loadDataFromServer() {
      let data = this.filterData;
      ApiService.post(`${this.item.url}`, data)
        .then((response) => {
          this.serverData = response.data.chart.values;
          this.series = response.data.chart.values.series;
          setTimeout(() => {
            this.isLoaded = true;
          }, 50);
        })
        .catch(() => {});
    },
  },
  mounted() {
    this.loadDataFromServer();
  },
  computed: {
    chartOptions: function () {
      return {
        colors: [
          "#5DA5DA",
          "#FAA43A",
          "#B2912F",
          "#F17CB0",
          "#DECF3F",
          "#3C1668",
        ],
        chart: {
          type: "donut",
        },
        // plotOptions: {
        //   pie: {
        //     startAngle: -90,
        //     endAngle: 90,
        //     offsetY: 10,
        //     customScale: 1,
        //   },
        // },
        grid: {
          padding: {
            bottom: 50,
          },
        },
        responsive: [
          {
            breakpoint: 480,
            options: {
              chart: {
                width: 390,
              },
              legend: {
                position: "bottom",
              },
            },
          },
        ],
        // fill: {
        //   // colors: this.serverData?.colors,
        //   colors: [
        //     "#5DA5DA",
        //     "#FAA43A",
        //     "#B2912F",
        //     "#F17CB0",
        //     "#DECF3F",
        //     "#3C1668",
        //   ],
        // },

        labels: this.labels,
        dataLabels: {
          enabled: true,
          formatter: function (val) {
            return String(val).slice(0, 3) + "%";
          },
        },
        legend: {
          show: true,
        },
        tooltip: {
          enabled: true,
          y: {
            formatter: (val) => String(val).slice(0, 5) + "%",
          },
        },
      };
    },
    labels: function () {
      if (!this.serverData?.labels?.length) return [];
      return this.serverData.labels.map((label) => {
        const raw = String(label);
        // API labels look like "Departed Origin (0)" — translate the base
        // status name and keep the trailing count suffix as-is so the legend
        // still shows totals next to each translated status.
        const match = raw.match(/^(.*?)(\s*\(\s*\d+\s*\))\s*$/);
        if (match) {
          const base = match[1].trim();
          const suffix = match[2];
          return `${this.translateApiLabel(base)}${suffix}`;
        }
        return this.translateApiLabel(raw);
      });
    },
  },
  watch: {
    filterData(newVal, oldVal) {
      if (JSON.stringify(newVal) !== JSON.stringify(oldVal)) {
        this.serverData = null;
        this.loadDataFromServer();
      }
    },
  },
};
//TODO::Dasboard:: delete old component
</script>

<style>
@media (max-width: 480px) {
  .apexcharts-legend.apx-legend-position-bottom {
    padding-bottom: 3rem !important;
  }
}

.donut-card-subtitle {
  text-align: start;
}
</style>
